<template>
  <div>
    <topNav></topNav>
    <div class="back">
      <div class="back1">
        <div class="back2"  @click="$router.push('education')"></div>
        <div class="back3"  @click="$router.push('education')">返回交易师列表</div>
      </div>
    </div>
    <div class="box">
      <div class="title">
        <div class="title1">{{ thisData.title }}</div>
        <div class="title2">
          <div class="title3"></div>
          <div class="title4">发布{{ thisData.published }}</div>
        </div>
      </div>
      <div class="vedio">
        <div class="boxin banmain videoDAbox">
          <video
            class="videoDA"
            id="videoDA"
            autoplay
            controls
            :src=thisData.video
            type="video/mp4"
          ></video>
          <div class="play" v-if="palyDA" id="play" @click="DAplay">
            <img
              src="../../common/images/productCenter/A1/paly.png"
              id="playbtn"
              class="playbtn"
              alt=""
            />
          </div>
          <img
            src="../../common/images/productCenter/A1/palying.png"
            class="playing"
            v-if="playingA"
            alt=""
          />
        </div>
      </div>
      <div class="explain">
        <p>免责声明：</p>
        <p>
          以上内容（包括但不限于图片、文章、音视频等）及操作仅供您参考和学习使用，不构成投资建议，不具有投资咨询性质，不构成对任何金融产品的购买、拋售或持有的建议，不作为您做任何投资的依据，不承诺您获得投资收益，本平台不作任何担保。您应该自主做出投资决策，自行承担投资风险和损失，投资有风险，入市需谨慎!
        </p>
      </div>
      <div class="introduceT">专栏简介</div>
      <div class="introduce">
        献礼100年党庆,金融实干报国
      </div>
      <div class="vedioT">视频列表</div>
      <div class="vedioLisi">
        <div
          class="vedioCard"
          :id="showTish == item.index ? 'vedioCard' : ''"
          @click="chooseVedio(item.index)"
          v-for="item in needData"
          :key="item.index"
        >
          <!-- <div
            class="vedioCard1"
            :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }"
          ></div> -->
          <img class="vedioCard1" :src="item.img" alt="" />

          <div class="vedioCard2" v-if="thisVideo != item.index">
            {{ item.title }}
          </div>
          <div class="vedioCard3" v-if="thisVideo == item.index">
            {{ item.title }}
          </div>
          <div class="vedioCard4">发布{{ item.published }}</div>
          <div class="vedioCard5" v-if="thisVideo == item.index">播放中</div>
        </div>
      </div>
      <el-pagination
        id="FY"
        @mouseleave="leave()"
        background
        prev-text='上一页'
        next-text='下一页'
        layout="prev, pager, next"
        :total="total"
        :page-size="8"
        @current-change="currentChangeHandle"
        :current-page="currentPage"
      >
      </el-pagination>
    </div>
    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "../sub/topNav";
import Bottoms from "../sub/Bottoms";
export default {
  name: "subjectVideo",
  components: { topNav, Bottoms },
  data() {
    return {
      id: "",

      showTish: 0,
      palyDA: true,
      playingA: false,
        videoUrl:'',
      currentPage: 1, //初始页
        thisVideo: 0, //选中的视频
      total: 0, //视频总数
      pageSize: 8, //每页的数据
      vedioLisi: [
        {
          imgUrl: "https://himg.bdimg.com/sys/portrait/item/wise.1.c44fa9e3.Wz8IrMLTWnLatsOHfCiVdA.jpg?time=9474",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-07",
          index: "0",
          videoUrl:'http://dexun-www.oss-cn-shenzhen.aliyuncs.com/team_lj.mp4'
        },
        {
          imgUrl: "https://himg.bdimg.com/sys/portrait/item/wise.1.44aef742.OqbHHE_u1QBRiB1uD8lVCA.jpg?time=2952",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-01",
          index: "1",
          videoUrl:'http://dexun-www.oss-cn-shenzhen.aliyuncs.com/team_wm.mp4'
        },
        {
          imgUrl: "",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-12",
          index: "2",
          videoUrl:'http://dexun-www.oss-cn-shenzhen.aliyuncs.com/team_lj.mp4'

        },
        {
          imgUrl: "",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-22",
          index: "3",
          videoUrl:'http://dexun-www.oss-cn-shenzhen.aliyuncs.com/team_wm.mp4'

        },
        {
          imgUrl: "",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-11",
          index: "4",
          videoUrl:'http://dexun-www.oss-cn-shenzhen.aliyuncs.com/team_rsw.mp4'

        },
        {
          imgUrl: "",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-03",
          index: "5",
        },
        {
          imgUrl: "",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-18",
          index: "6",
        },
        {
          imgUrl: "",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-21",
          index: "7",
        },
        {
          imgUrl: "https://himg.bdimg.com/sys/portrait/item/wise.1.44aef742.OqbHHE_u1QBRiB1uD8lVCA.jpg?time=2952",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-01",
          index: "8",
        },
        {
          imgUrl: "https://himg.bdimg.com/sys/portrait/item/wise.1.44aef742.OqbHHE_u1QBRiB1uD8lVCA.jpg?time=2952",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-01",
          index: "9",
        },
        {
          imgUrl: "https://himg.bdimg.com/sys/portrait/item/wise.1.44aef742.OqbHHE_u1QBRiB1uD8lVCA.jpg?time=2952",
          name: "龙腾四海战法--2旭日东升",
          time: "2022-02-01",
          index: "10",
        },
      ],
       needData: [{ img: "", published: "", title: "", video: "" }],
      thisData: [{ img: "", published: "", title: "", video: "" }],
      record: {
        page: 1,
        thisItem: "",
      },
      teacherbrief: {
        brief: "",
        id: '',
        img: "",
        name: "",
        teacher_brief: " ",
        teacher_name: " ",
        teacher_number: "",
        teacher_title: " ",
      },
    };
  },
  mounted() {
      window.scrollTo(0, 0);
    var teacher = localStorage.getItem("subject");
    var json = JSON.parse(teacher);
    this.teacherbrief = json;

    // this.getdata();
    this.DAplayState();
     this.initfun(this.$route.query.id, 1, 8, 88);
    this.id = this.$route.query.id;
  },
  methods: {
    // 获取视频
    initfun: function (id, page, limit, isthis) {
      this.$api.tjzxVideo_list(id, page, limit).then((res) => {
        if (res.code == 0) {
          if (isthis == 88) {
            this.thisData = res.data.list[0];
          }
          this.needData = res.data.list;
          this.total = res.data.total;
          this.videoUrl = res.data.list[0].video;
          this.needData.map(function (item, a, b) {
            item.index = a;
          });
        }
      });
    },


         // 视频
    DAplay: function () {
      let video = document.getElementById("videoDA");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
        DAplayState: function () {
      let that = this;
      let ele = document.getElementById("videoDA");
      ele.addEventListener("play", function () {
        //播放开始执行的函数
        //console.log(1);
        that.palyDA = false;
        that.playingA = true;
        let s = setTimeout(function () {
          that.playingA = false;
          clearTimeout(s);
        }, 200);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.palyDA = true;
      });
      setTimeout(()=>{
      this.videoUrl = this.vedioLisi[0].videoUrl;
console.log('倒计时结束')
      },500)
    },
    // 分頁
    currentChangeHandle(val) {
      if (val == this.record.page) {
        this.thisVideo = this.record.thisItem;
      } else {
        this.thisVideo = "";
      }
      this.currentPage = val;
      this.initfun(this.id, val, 8);
    },
    // getdata() {
    //   var data = this.vedioLisi;
    //   var currentPage = this.currentPage;
    //   var result = [];
    //   for (var i = 0, len = data.length; i < len; i += 8) {
    //     result.push(data.slice(i, i + 8));
    //   }
    //   console.log("分割后的数据", result);
    //   this.needData = result[currentPage - 1];
    // },
    chooseVedio: function (n) {
       this.thisVideo = n;
       this.showTish = n;
      this.record.page = this.currentPage;
      this.record.thisItem = n;
      this.thisData = this.needData[n];
      this.palyDA = true;
      this.playingA = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
.back {
  width: 100%;
  height: 50px;
  background: #f4f4f4;
  opacity: 1;
}
.back1 {
  display: flex;
  width: 1226px;
  height: 50px;
  margin: 0 auto;
}
.back2 {
  width: 18px;
  height: 18px;
  margin: 18px 12px 0 0;
  background: url("../../common/images/education/back.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.back3 {
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-top: 16px;
  cursor: pointer;
  text-align: left;
}

/* 主要内容 */
.box {
  position: relative;
  background-color: #fff;
  padding: 0px 0 60px 0;
}
.title {
  display: flex;
  justify-content: space-between;
  width: 980px;
  height: 67px;
  margin: 0 auto;
}
.title1 {
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #1d1d1d;
  margin-top: 30px;
}
.title2 {
  display: flex;
  height: 67px;
}
.title3 {
  width: 16px;
  height: 16px;
  background: url("../../common/images/education/date.png") no-repeat;
  margin: 45px 8px 0 0;
}
.title4 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-top: 42px;
}
/* 視頻 */

.vedio {
  width: 980px;
  height: 552px;
  margin: 20px auto 0;
  background-color: #ccc;
}
.videoDAbox,
.videoDBbox {
  position: relative;
}
.banmain {
  height: 552px;
}

.videoDA,
.videoDB,
.videoDC {
  width: 980px;
  height: 552px;
}
.videoDAbox .play,
.videoDBbox .play {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 552px;
  background: linear-gradient(rgba(80, 80, 80, 0.3), rgba(80, 80, 80, 0));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}
.videoDAbox .playing,
.videoDBbox .playing {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -45px;
  margin-top: -30px;
}
.videoDAbox .playbtn,
.videoDBbox .playbtn {
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 30px;
}
.explain {
  padding: 16px 20px 0 20px;
  margin: 20px auto 0;
  text-align: left;
  width: 1226px;
  height: 110px;
  background-color: #f2f2f2;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.introduceT {
  width: 1226px;
  height: 44px;
  margin: 12px auto 0;
  text-align: left;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #888888;
  line-height: 44px;
  border-bottom: 1px solid #d5d5d5;
}
.introduce {
  width: 1226px;
  margin: 20px auto 0;
font-size: 22px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #666666;
text-align: left;
}


.vedioT {
  width: 1226px;
  height: 57px;
  margin: 42px auto 0;
  text-align: left;
  font-size: 26px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 57px;
  border-bottom: 1px solid #d5d5d5;
}

.vedioLisi {
  display: flex;
  flex-wrap: wrap;
  width: 1226px;
  margin: 16px auto 0;
}
.vedioCard {
  position: relative;
  width: 302px;
  height: 251px;
  background: #ffffff;
  opacity: 1;
  padding: 6px 6px 0 6px;
  margin-right: 4px;
  margin-top: 20px;
  cursor: pointer;
}
#vedioCard {
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.18);
  border-radius: 6px 6px 6px 6px;
}
.vedioCard1 {
  width: 290px;
  height: 152px;
  background-size: 100% 100%;
  background-color: #ccc;
}
.vedioCard2 {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  margin-top: 20px;
  text-align: left;
 overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
}
.vedioCard3 {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #e7413b;
  line-height: 25px;
  margin-top: 16px;
  text-align: left;
  overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
}
.vedioCard4 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  margin-top: 10px;
  text-align: left;
}
.vedioCard5 {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 290px;
  height: 152px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 6px 6px 6px 6px;
  font-weight: 400;
  font-family: PingFang SC-Regular, PingFang SC;
  font-size: 26px;
  color: #ffffff;
  line-height: 152px;
}
#FY {
  margin-top: 57px;
}
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}

.into {
  width: 136px;
  height: 38px;
  margin: 30px auto 0;
  background: url("../../common/images/education/intoN.png") no-repeat;
  background-size: 100% 100%;

  cursor: pointer;
}
.into:hover {
  background: url("../../common/images/education/intoY.png") no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/educationView/subjectVideo.vue